import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../axiosBaseQuery";


const meaPurificationApi = createApi({
    reducerPath: "core/measurement/purification",
    baseQuery: axiosBaseQuery,
    tagTypes: ["measurementPurificationList"],
    endpoints: (builder) =>({
        measurementPurificationFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['measurementPurificationList'],
            query: (query = '') => ({
                url: "core/measurement/purification" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        measurementPurificationCreate: builder.mutation({
            invalidatesTags: ['measurementPurificationList'],
            query: (data)=>({url: "core/measurement/purification", method: "POST", data})
        }),
        measurementPurificationUpdate: builder.mutation({
            invalidatesTags: ['measurementPurificationList'],
            query: (data)=>({url: "/core/measurement/purification/"+data.id, method: "PUT", data})
        }),
        measurementPurificationDelete: builder.mutation({
            invalidatesTags: ['measurementPurificationList'],
            query: (id)=>({url: "/core/measurement/purification/"+id, method: "DELETE"})
        }),
    })
})

export const { useMeasurementPurificationFindAllQuery, useMeasurementPurificationCreateMutation, useMeasurementPurificationUpdateMutation, useMeasurementPurificationDeleteMutation } = meaPurificationApi;
export {meaPurificationApi};
